import React, { useEffect, useState } from "react";
import {
    ModalWrapper,
    ModalButtonsContainer,
    Backdrop,
    ModalContainer,
    Title,
    ModalHeaderContainer,
    GenericListContainer,
} from "./ActionLibrary.styled";
import { useStore } from "../../../../hooks";
import { RoundedButton } from "../../../button";
import ActionItem from "../ActionItem";
import { actions } from "../consts";
import { toJS } from "mobx";
import { Settings } from "@mui/icons-material";
import {
  ActionsLibraryMessages,
  SUCCESS_ALERT_DURATION,
} from "../../../../utils/enums";
import Alerts from "../../Alerts/Alerts";
import { observer } from "mobx-react";

const ActionLibrary = observer(
  ({ isOpen, onClose, onSave, initialAgentActions, isAdmin, isSuperAdmin }) => {
    const handleClose = () => {
        onClose();
    };

    const [availableActions, setAvailableActions] = useState(
      Object.keys(actions)
    );
    const [agentActions, setAgentActions] = useState([]);
    const [showSuccessSetupAlert, setShowSuccessSetupAlert] = useState(false);
    const [showIncompleteConfigAlert, setShowIncompleteConfigAlert] =
      useState(false);
    const { editAgent } = useStore();
    const [showDiscardChangesAlert, setShowDiscardChangesAlert] =
      useState(false);

    useEffect(() => {
      if (initialAgentActions && initialAgentActions.length) {
        setAgentActions(initialAgentActions);
        setAvailableActions(
          availableActions.filter(
            (action) => !initialAgentActions.includes(action)
          )
        );
      }
    }, [initialAgentActions]);

    const switchAction = (
      origin,
      setOrigin,
      destination,
      setDestination,
      idx,
      value
    ) => {
      const currentList = [...origin];
      currentList.splice(idx, 1);
      setOrigin(currentList);

      setDestination([...destination, value]);
    };

    const addAction = (idx, action) =>
      switchAction(
        availableActions,
        setAvailableActions,
        agentActions,
        setAgentActions,
        idx,
        action
      );
    const removeAction = (idx, action) =>
      switchAction(
        agentActions,
        setAgentActions,
        availableActions,
        setAvailableActions,
        idx,
        action
      );

    const handleSave = () => {
      const requiredToConfigure = ["appointment_schedule", "repair_schedule"];
      const selectedConfigurableActions = agentActions.filter((action) =>
        requiredToConfigure.includes(action)
      );
        
      if (selectedConfigurableActions.length > 0) {
        const hasCompleteConfig = selectedConfigurableActions.every(
          (action) => editAgent.actionsSettings.find((setting) => setting[action])
        );
        if (!hasCompleteConfig) {
          setShowIncompleteConfigAlert(true);
          setTimeout(() => {
            setShowIncompleteConfigAlert(false);
          }, 3000);
          return;
        }
      }
      onSave(agentActions);
      handleClose();
      setShowSuccessSetupAlert(true);
      setTimeout(() => {
        setShowSuccessSetupAlert(false);
      }, SUCCESS_ALERT_DURATION);
    };

    return (
      <>
        <Backdrop isOpen={isOpen}>
          <ModalWrapper>
            <ModalHeaderContainer>
              <Title>Actions Library</Title>
              <ModalButtonsContainer>
                <RoundedButton
                  weight="400"
                  width={"80px"}
                  borderRadius={"8px"}
                  kind={"secondary"}
                  onClick={() => handleClose()}
                >
                  Cancel
                </RoundedButton>
                <RoundedButton
                  weight="400"
                  width={"80px"}
                  borderRadius={"8px"}
                  kind={"primary"}
                  onClick={handleSave}
                >
                  Save
                </RoundedButton>
              </ModalButtonsContainer>
            </ModalHeaderContainer>
            {showIncompleteConfigAlert && (
              <Alerts
                severity="warning"
                isInline
                title={ActionsLibraryMessages.INCOMPLETE_SETUP.title}
                message={ActionsLibraryMessages.INCOMPLETE_SETUP.message}
              />
            )}
            {editAgent.actionsSettingsTouched && (
              <Alerts
                severity="warning"
                isInline
                title={ActionsLibraryMessages.DISCARD_CHANGES.title}
                message={ActionsLibraryMessages.DISCARD_CHANGES.message}
              />
            )}
            <ModalContainer>
              <div>
                <Title>Available actions</Title>
                <GenericListContainer>
                  {availableActions.map((actionId, idx) => {
                    const action = actions[actionId];
                    return (
                      action &&
                      ((action.superAdminOnly && isSuperAdmin) ||
                        !action.superAdminOnly ||
                        isAdmin) && (
                        <ActionItem
                          key={idx}
                          icon={action.icon}
                          title={action.title}
                          subtitle={action.description}
                          onClick={() => addAction(idx, actionId)}
                          arrowDirection="right"
                        />
                      )
                    );
                  })}
                </GenericListContainer>
              </div>
              <div>
                <Title>Agent actions</Title>
                <GenericListContainer>
                  {agentActions.map((actionId, idx) => {
                    const action = actions[actionId];
                    return (
                      action && (
                        <ActionItem
                          key={idx}
                          icon={action.icon}
                          title={action.title}
                          subtitle={action.description}
                          onClick={() => removeAction(idx, actionId)}
                          ConfigurationIcon={Settings}
                          arrowDirection="left"
                        />
                      )
                    );
                  })}
                </GenericListContainer>
              </div>
            </ModalContainer>
          </ModalWrapper>
        </Backdrop>
        {showSuccessSetupAlert && (
          <Alerts
            severity="success"
            title={ActionsLibraryMessages.SETUP_SUCCESS.title}
            message={ActionsLibraryMessages.SETUP_SUCCESS.message}
          />
        )}
      </>
    );
  }
);

export default ActionLibrary;
